// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1QMvY","rootSuccess":"CompleteLink_rootSuccess__-YJ4L","rootFailure":"CompleteLink_rootFailure__1gZ7F","isDisabled":"CompleteLink_isDisabled__10u68"};